/*routes with roles guards and menu display rules*/

import Vue from "vue";
import VueRouter from "vue-router";
import store from "./store/index";

Vue.use(VueRouter);

const accessIsAllowed = (routeMeta) => {
  return routeMeta.roles.includes(store.getters.userRole);
};

export const routes = [
  {
    path: "/",
    component: () => import("./layouts/Main/Main"),
    props: true,
    children: [
      {
        path: "/",
        name: "home",
        component: () => import("./views/home/Home"),
        props: true,
        meta: {
          title: "Мои ленты",
          icon: "list",
          auth: true,
          showInMenu: true,
          singlePage: false,
          roles: [
            "operator",
            "manager",
            "admin"
          ]
        },
      },
      {
        path: "/analytics/:threadId",
        name: "feedAnalytics",
        component: () => import("./views/analytics/Analytics"),
        props: true,
        meta: {
          auth: true,
          showInMenu: false,
          singlePage: false,
          roles: [
            "operator",
            "manager",
            "admin"
          ]
        },
      },
      {
        path: "/common/:threadId/:chart/edit",
        name: "feedAnalyticsEdit",
        component: () => import("./views/analyticsEdit/AnalyticsEdit"),
        props: true,
        meta: {
          auth: true,
          showInMenu: false,
          singlePage: true,
          roles: [
            "operator",
            "manager",
            "admin"
          ]
        },
      },
      {
        path: "/audit/:threadId/:chart/edit",
        name: "feedAuditEdit",
        component: () => import("./views/auditEdit/AuditEdit"),
        props: true,
        meta: {
          auth: true,
          showInMenu: false,
          singlePage: true,
          roles: [
            "operator",
            "manager",
            "admin"
          ]
        },
      },
      {
        path: "/:threadId/settings",
        name: "feedSettings",
        component: () => import("./views/feedSettings/FeedSettings"),
        props: true,
        meta: {
          auth: true,
          showInMenu: false,
          singlePage: false,
          roles: [
            "operator",
            "manager",
            "admin"
          ]
        },
      },
    ]
  },
  {
    path: "/users",
    component: () => import("./layouts/Main/Main"),
    props: true,
    children: [
      {
        path: "/users",
        name: "users",
        component: () => import("./views/users/Users"),
        props: true,
        meta: {
          title: "Пользователи",
          icon: "person",
          auth: true,
          showInMenu: true,
          singlePage: false,
          roles: [
            "manager",
            "admin"
          ]
        },
      }
    ]
  },
  {
    path: "/auth",
    component: () => import("./layouts/Main/Main"),
    props: true,
    children: [
      {
        path: "/auth",
        name: "auth",
        component: () => import("./views/auth/Auth"),
        props: true,
        meta: {
          title: "Авторизации",
          icon: "login",
          auth: true,
          showInMenu: false,
          singlePage: false,
          roles: [
            "admin",
            "1192"
          ]
        },
      }
    ]
  },
  {
    path: "/ext-users",
    component: () => import("./layouts/Main/Main"),
    props: true,
    children: [
      {
        path: "/ext-users",
        name: "extUsers",
        component: () => import("./views/extUsers/ExtUsers"),
        props: true,
        meta: {
          title: "Внешние пользователи",
          icon: "group",
          auth: true,
          showInMenu: true,
          singlePage: false,
          roles: [
            "admin"
          ]
        },
      }
    ]
  },
  {
    path: "/iao-guides",
    component: () => import("./layouts/Main/Main"),
    props: true,
    children: [
      {
        path: "/iao-guides",
        name: "iaoGuides",
        component: () => import("./views/iaoGuides/IaoGuides"),
        props: true,
        meta: {
          title: "Справочники ИАО",
          icon: "supervised_user_circle",
          auth: true,
          showInMenu: true,
          singlePage: false,
          roles: [
            "admin"
          ]
        },
      }
    ]
  },
  {
    path: "/guides",
    component: () => import("./layouts/Main/Main"),
    props: true,
    children: [
      {
        path: "/guides",
        name: "guides",
        component: () => import("./views/guides/Guides"),
        props: true,
        meta: {
          title: "Справочники",
          icon: "ballot",
          auth: true,
          showInMenu: true,
          singlePage: false,
          roles: [
            "manager",
            "admin"
          ]
        },
      }
    ]
  },

  {
    path: "/events",
    component: () => import("./layouts/Main/Main"),
    props: true,
    children: [
      {
        path: "/events",
        name: "events",
        component: () => import("./views/events/Events"),
        props: true,
        meta: {
          title: "Запросы на создание событий",
          icon: "queue",
          auth: true,
          showInMenu: false,
          singlePage: false,
          roles: [
            "manager",
            "admin",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "1028",
            "1075",
          ]
        },
      }
    ]
  },
  
  {
    path: "/themes",
    component: () => import("./layouts/Main/Main"),
    props: true,
    children: [
      {
        path: "/themes",
        name: "themes",
        component: () => import("./views/themes/Themes"),
        props: true,
        meta: {
          title: "Тематики",
          icon: "dataset",
          auth: true,
          showInMenu: true,
          singlePage: false,
          roles: [
            "manager",
            "admin"
          ]
        },
      }
    ]
  },
  {
    path: "/directory",
    component: () => import("./layouts/Main/Main"),
    props: true,
    children: [
      {
        path: "/directory",
        name: "directory",
        component: () => import("./views/directory/Directory"),
        props: true,
        meta: {
          title: "Доступ к справочникам",
          icon: "contacts",
          auth: true,
          showInMenu: true,
          singlePage: false,
          roles: [
            "admin"
          ]
        },
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./layouts/Login/Login"),
  },
  {
    path: "/denied",
    name: "denied",
    component: () => import("./layouts/Denied/Denied"),
  },
  {
    path: "/404",
    name: "404",
    component: () => import("./layouts/NotFound/NotFound"),
  },
  {
    path: "/500",
    name: "serverError",
    component: () => import("./layouts/serverError/serverError"),
  },
  {
    path: "/defaultError",
    name: "defaultError",
    component: () => import("./layouts/unknownError/unknownError"),
  },
  {
    path: '*',
    redirect: '/404',
  }
];

export const router = new VueRouter({
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  mode: 'history',
  base: process.env.BASE_URL,
});

router.beforeEach((to, from, next) => {
  console.log("GGGG", store);
  if (to.matched.some(record => record.meta.auth)) {
    if (store.getters.isAuthenticated && accessIsAllowed(to.meta)) {
      next();
    } else if (store.getters.isAuthenticated && !accessIsAllowed(to.meta)){
      next('/denied');
    } else if (!store.getters.isAuthenticated) {
      next('/login');
    }
  } else {
    next()
  }
});
